<div class="price" [style.color]="disabled ? '#ccc' : ''">
  @if (formattedPrice) {
    <span >{{ formattedPrice }}</span>
  }
  @if (currencySlug) {
    <span class="scale">{{ currencySlug }}</span>
  }
</div>
@if (nbInvestments) {
  <div class="nb_capex link" (click)="openSpreadsheet($event)" [style.color]="disabled ? '#ccc' : ''">
    @if (!hypothesis && (!replacementYear || nbInvestments > 1)) {
      {{ 'theme.displayed-note.nb_capex' | translate:{nbInvestments: nbInvestments} }}
    }
    @if (hypothesis && (!replacementYear || nbInvestments > 1)) {
      {{ '{investNb} hypothesis investment' | translate:{investNb: nbInvestments} }}
    }
    @if (replacementYear && nbInvestments === 1) {
      {{ 'Replacement in' | translate }} {{ replacementYear }}
    }
  </div>
}
